package com.macrofocus.eflux.ui.mui.themes

import js.objects.unsafeJso
import mui.material.PaletteMode
import mui.material.styles.Theme
import mui.material.styles.TypographyOptions
import mui.material.styles.TypographyVariant
import mui.material.styles.createTheme
import org.mkui.color.colorOf
import web.cssom.integer
import web.cssom.rem
import kotlin.js.unsafeCast

private val TYPOGRAPHY_OPTIONS = TypographyOptions {
    fontWeight = integer(500)

    TypographyVariant.h6 {
        fontSize = 1.5.rem

//        media(maxWidth(599.px)) {
//            fontSize = 1.25.rem
//        }
    }
}

object Themes {
    val Light = createTheme(
        unsafeJso {
            palette = unsafeJso { asDynamic().mode = PaletteMode.light }
            typography = TYPOGRAPHY_OPTIONS

            asDynamic().backgroundColor = arrayOf(252, 252, 252)
            asDynamic().switzerlandFill = "#e2e2e2"
            asDynamic().switzerlandFillColor = colorOf("#e2e2e2")
            asDynamic().substation = arrayOf(102, 102, 102) // "#666666"
            asDynamic().substationColor = colorOf(102, 102, 102) // "#666666"
            asDynamic().substationFill = arrayOf(255, 255, 255) // "#ffffff"
            asDynamic().substationFillColor = colorOf(255, 255, 255) // "#ffffff"
            asDynamic().label = arrayOf(102, 102, 102) // "#666666"
            asDynamic().kv380 = arrayOf(115, 70, 162) // #7346A2
            asDynamic().kv220 = arrayOf(23, 175, 151) // #17af97
            asDynamic().kv150 = arrayOf(42, 156, 244) // #2a9cf4
            asDynamic().outOfService = arrayOf(188, 188, 188) // arrayOf(255, 0, 0)
            asDynamic().invalid = arrayOf(188, 188, 188)
            asDynamic().kv380Color = colorOf(115, 70, 162) // #7346A2
            asDynamic().kv220Color = colorOf(23, 175, 151) // #17af97
            asDynamic().kv150Color = colorOf(42, 156, 244) // #2a9cf4
            asDynamic().outOfServiceColor = colorOf(188, 188, 188) // arrayOf(255, 0, 0)
            asDynamic().invalidColor = colorOf(188, 188, 188)
        }
    ).unsafeCast<Theme>()

    val Dark = createTheme(
        unsafeJso {
            palette = unsafeJso { asDynamic().mode = PaletteMode.dark }
            typography = TYPOGRAPHY_OPTIONS

            asDynamic().backgroundColor = "#062333"
            asDynamic().switzerlandFill = "#0b374f"
            asDynamic().substation = arrayOf(136, 136, 136) // "#888888"
            asDynamic().substationColor = colorOf(136, 136, 136) // "#888888"
            asDynamic().substationFill = arrayOf(11, 55, 79) // "#0b374f"
            asDynamic().substationFillColor = colorOf(11, 55, 79) // "#0b374f"
            asDynamic().label = arrayOf(209, 209, 209)
            asDynamic().kv380 = arrayOf(131, 94, 172) // #835eac
            asDynamic().kv220 = arrayOf(38, 141, 5) // #268d05
            asDynamic().kv150 = arrayOf(42, 156, 244) // #2a9cf4
            asDynamic().outOfService = arrayOf(135, 135, 135) // arrayOf(255, 0, 0)
            asDynamic().invalid = arrayOf(135, 135, 135)
            asDynamic().kv380Color = colorOf(131, 94, 172) // #835eac
            asDynamic().kv220Color = colorOf(38, 141, 5) // #268d05
            asDynamic().kv150Color = colorOf(42, 156, 244) // #2a9cf4
            asDynamic().outOfServiceColor = colorOf(135, 135, 135) // arrayOf(255, 0, 0)
            asDynamic().invalidColor = colorOf(135, 135, 135)
        }
    ).unsafeCast<Theme>()

    val LightDiviso = createTheme(
        unsafeJso {
            palette = unsafeJso {
                asDynamic().mode = PaletteMode.light

                asDynamic().primary = unsafeJso {
                    main = "#323232" // "#e65100"
                }
                asDynamic().secondary = unsafeJso {
                    main = "#575757" // "#fff09f"
                }
                asDynamic().background = unsafeJso {
                    paper = "#ffffff"
                    default = "#fafafa"
                }
            }
            typography = TYPOGRAPHY_OPTIONS

            asDynamic().backgroundColor = "#fcfcfc" // arrayOf(252, 252, 252)
            asDynamic().switzerlandFill = "#e6e6e6" // arrayOf(230, 230, 230)
            // Same as dark because line color doesn't update!
//            asDynamic().substation = arrayOf(102, 102, 102) // "#666666"
            asDynamic().substation = arrayOf(102, 102, 102) // "#666666"
            asDynamic().substationColor = colorOf(102, 102, 102) // "#666666"
            asDynamic().substationFill = arrayOf(255, 255, 255) // "#ffffff"
            asDynamic().substationFillColor = colorOf(255, 255, 255) // "#ffffff"
            asDynamic().label = arrayOf(102, 102, 102) // "#666666"
            asDynamic().kv380 = arrayOf(242, 130, 0)
            asDynamic().kv220 = arrayOf(42, 156, 244)
            asDynamic().kv150 = arrayOf(171, 144, 199) // #ab90c7
            asDynamic().outOfService = arrayOf(188, 188, 188)
            asDynamic().invalid = arrayOf(188, 188, 188)
            asDynamic().kv380Color = colorOf(242, 130, 0)
            asDynamic().kv220Color = colorOf(42, 156, 244)
            asDynamic().kv150Color = colorOf(171, 144, 199) // #ab90c7
            asDynamic().outOfServiceColor = colorOf(188, 188, 188)
            asDynamic().invalidColor = colorOf(188, 188, 188)
        }
    ).unsafeCast<Theme>()

    val DarkDiviso = createTheme(
        unsafeJso {
            palette = unsafeJso { asDynamic().mode = PaletteMode.dark
                asDynamic().primary = unsafeJso {
                    main = "#fcfcfc" // "#ffcc80"
                }
                asDynamic().secondary = unsafeJso {
                    main = "#e6e6e6" // "#fff09f"
                }
                asDynamic().background = unsafeJso {
                    // General background color
                    paper = "#182f3c" // "#303030"
                    // App bar background color
                    default = "#0e2232" // "#051e2c" // "#121212"
                }
            }
            typography = TYPOGRAPHY_OPTIONS

            asDynamic().backgroundColor = "#323232" // arrayOf(50, 50, 50)
            asDynamic().switzerlandFill = "#575757" // arrayOf(87, 87, 87)
            asDynamic().substation = arrayOf(136, 136, 136) // "#888888"
            asDynamic().substationColor = colorOf(136, 136, 136) // "#888888"
            asDynamic().substationFill = arrayOf(50, 50, 50) // "#323232"
            asDynamic().substationFillColor = colorOf(50, 50, 50) // "#323232"
            asDynamic().label = arrayOf(209, 209, 209)
            asDynamic().kv380 = arrayOf(242, 130, 0)
            asDynamic().kv220 = arrayOf(42, 156, 244)
            asDynamic().kv150 = arrayOf(143, 107, 181) // #8f6bb5
            asDynamic().outOfService = arrayOf(135, 135, 135)
            asDynamic().invalid = arrayOf(135, 135, 135)
            asDynamic().kv380Color = colorOf(242, 130, 0)
            asDynamic().kv220Color = colorOf(42, 156, 244)
            asDynamic().kv150Color = colorOf(143, 107, 181) // #8f6bb5
            asDynamic().outOfServiceColor = colorOf(135, 135, 135)
            asDynamic().invalidColor = colorOf(135, 135, 135)
        }
    ).unsafeCast<Theme>()
}